import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import SponserRow from './SponserRow.jsx';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import ConferenceDropdown from '../../Forms/ConferenceDropdown.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Sponsers = () => {
  const [sponsors, setSponsors] = useState([]);
  const { SetNotification } = useStateContext();
  const [loading, setLoading] = useState(true);
  const [conferenceId, setConferenceId] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await AxiosClient.get(`/conference/${conferenceId}/sponsors`);
        setSponsors(response.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
        SetNotification('Error fetching data', 'danger');
      } finally {
        setLoading(false);
      }
    };
    if (conferenceId)
      fetchData();

  }, [conferenceId]);

  const handleDeleteSponsor = async (id) => {
    try {
      await AxiosClient.delete(`/sponsors/${id}`);
      setSponsors(sponsors.filter(sponsor => sponsor.id !== id));
      SetNotification('A sponsor has been deleted', 'success');
    } catch (error) {
      console.error(error);
      SetNotification('Error while deleting the sponsor', 'danger');
    }
  };

  return (
    <>
      <PageHeader
        title="Sponsors"
        description="Manage conference partners and sponsorship details."
        actions={conferenceId && (
          <Link className="btn btn-primary" to={`./Add/${conferenceId}`}>
            <i className="material-icons" aria-hidden="true">add</i>
            Add sponsor
          </Link>
        )}
      />
      <PageToolbar filters={<ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />} />

      {!conferenceId ? (
        <div className="workspace-empty">Select a conference to manage its sponsors.</div>
      ) : loading ? (
        <div className="workspace-loading"><Loader label="Loading sponsors..." /></div>
      ) : sponsors && sponsors.length > 0 ? (
        <DataTable>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Logo</th>
                          <th>Website</th>
                          <th>Type</th>
                          <th>Active</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sponsors.map(sponsor => (
                          <SponserRow
                            key={sponsor.id}
                            name={sponsor.name}
                            description={sponsor.description}
                            logo={sponsor.logo}
                            website={sponsor.website}
                            type={sponsor.type}
                            active={sponsor.active}
                            id={sponsor.id}
                            onDelete={handleDeleteSponsor}
                          />
                        )) }
                      </tbody>
        </DataTable>
      ) : (
        <div className="workspace-empty">No sponsors found for this conference.</div>
      )}
    </>
  );
};

export default Sponsers;
